export default __webpack_public_path__ + "static/media/13_zniwa.0a54759e.png";